var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"activity-logs__log"},[_c('CreatedAt',{attrs:{"log":_vm.log}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.activityMessage)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }